import React from "react";
import type { UnitPriceRank } from "../../unit-price";

interface Props {
  value: number;
  unit: string;
  rank: UnitPriceRank | null;
}

const RANK_STYLES: Record<string, string> = {
  best: "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300",
  mid: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300",
  worst: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
};

export function UnitPriceBadge({ value, unit, rank }: Props) {
  const style = rank ? RANK_STYLES[rank] : RANK_STYLES.mid;
  return (
    <span className={`inline-block text-[11px] font-semibold px-1.5 py-0.5 rounded ${style}`}>
      R$ {value.toFixed(2)}/{unit}
    </span>
  );
}
